import http from '~/common/http'
export default {
    // 成交订单分析统计
    getList(params) {
        return http.get('/api/customer-cooperator/index', {
            params: params
        });
    },
    create(data) {
        return http.post("/api/customer-cooperator/create", data);
    },

    update(data) {
        return http.put("/api/customer-cooperator/update", data);
    },

    delete(id) {
        return http.delete("/api/customer-cooperator/delete", {
            params: {
                id: id
            }
        });
    },
    // 协作人导入
    importCooprator(formData) {
        return http.post('/api/customer-cooperator/import-cooprator', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/CustomerCooperator.js